import { EnumDropdown, EnumDropdownProps } from 'framework/form';
import { PROJECT_TEAM_TYPE_LABELS } from '../constants';

const ProjectTeamTypeDropdown = (props: Omit<EnumDropdownProps, 'options'>) => {
  return <EnumDropdown {...props} options={PROJECT_TEAM_TYPE_LABELS} />;
};

export default ProjectTeamTypeDropdown;
